export const MultidialogStatus = Object.freeze({
	new: 'new',
	open: 'open',
	close: 'close',
});
